import { render, staticRenderFns } from "./ReportedUserListView.vue?vue&type=template&id=d8ae8eae&"
import script from "./ReportedUserListView.vue?vue&type=script&lang=js&"
export * from "./ReportedUserListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports